import { Component } from '@angular/core';
import { ProductListComponent } from '../../../components/user-dashboard-component/products/product-list-component/product-list-component';

@Component({
  selector: 'app-user-products',
  imports: [ProductListComponent],
  templateUrl: './user-products.html',
  styleUrl: './user-products.scss',
})
export class UserProducts {}
